import { render, staticRenderFns } from "./TransportStatusChip.vue?vue&type=template&id=dc690660"
import script from "./TransportStatusChip.vue?vue&type=script&lang=ts"
export * from "./TransportStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports